import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Checkbox from "../../Elements/Checkbox/Checkbox";
import "../CheckoutPanel/CheckoutPanel.css";

const LegalFooter = ({
  isGuest,
  newsletterOptIn,
  onNewsletterOptInChange,
  speedConfirmed,
  onSpeedConfirmChange,
  isUnlimited,
  showNewsletterCheckbox,
  onNewsletterOptInGuestChange,
}) => {
  const showSpeedCheckbox = isUnlimited;

  return (
    <>
      {isGuest ? (
        <div className="summary-legal-guest">
          <span className="summary-legal__text">
            By clicking "Place Order" you agree to{" "}
            <Link to="/terms" className="summary-legal__link">
              Terms and Conditions
            </Link>{" "}
            and{" "}
            <Link to="/privacy-policy" className="summary-legal__link">
              Privacy Policy
            </Link>
            .
          </span>

          {showSpeedCheckbox && (
            <Checkbox
              id="speed-warning-guest"
              label={
                <>
                  I understand that speed may be reduced after high data usage{" ("}
                  <HashLink
                    to="/terms#art-17-unlimited"
                    className="summary-legal__link"
                    scroll={(el) =>
                      el.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                      })
                    }
                  >
                    Unlimited Plan Details
                  </HashLink>
                  {")"}.
                </>
              }
              checked={speedConfirmed}
              onChange={(e) => onSpeedConfirmChange(e.target.checked)}
            />
          )}
        </div>
      ) : (
        <div className="summary-legal">
          <span className="summary-legal__text">
            By clicking "Place Order" you agree to{" "}
            <Link to="/terms" className="summary-legal__link">
              Terms and Conditions
            </Link>{" "}
            and{" "}
            <Link to="/privacy-policy" className="summary-legal__link">
              Privacy Policy
            </Link>
            .
          </span>

          {showSpeedCheckbox && (
            <Checkbox
              id="speed-warning-user"
              label={
                <>
                  I understand that speed may be reduced after high data usage{" ("}
                  <HashLink
                    to="/terms#art-17-unlimited"
                    className="summary-legal__link"
                    scroll={(el) =>
                      el.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                      })
                    }
                  >
                    Unlimited Plan Details
                  </HashLink>
                  {")"}.
                </>
              }
              checked={speedConfirmed}
              onChange={(e) => onSpeedConfirmChange(e.target.checked)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default LegalFooter;
